import { IUser, IGame } from "./IUser";
import { RepoAsync } from "./repoToggle";

export class LocalRepo {
  private USERS_KEY = 'skeech_users';
  private GAMES_KEY = 'skeech_games';
  private CUR_KEY = 'skeech_currentUserId';

  private load<T>(key: string, fallback: T): T {
    try { const raw = localStorage.getItem(key); return raw ? JSON.parse(raw) as T : fallback; } catch { return fallback; }
  }
  private save<T>(key: string, value: T) { localStorage.setItem(key, JSON.stringify(value)); }

  listUsers(): IUser[] { return this.load<IUser[]>(this.USERS_KEY, []); }
  listGames(): IGame[] { return this.load<IGame[]>(this.GAMES_KEY, []); }

  getCurrentUser(): IUser | null {
    const id = localStorage.getItem(this.CUR_KEY);
    if (!id) return null;
    return this.listUsers().find(u => u.id === id) || null;
  }
  rememberUser(id: string) { localStorage.setItem(this.CUR_KEY, id); }
  logout() { localStorage.removeItem(this.CUR_KEY); }

  getUserByName(name: string): IUser | null {
    const n = name.trim().toLowerCase();
    return this.listUsers().find(u => u.userName.trim().toLowerCase() === n) || null;
  }

  getUserById(id: string): IUser | null {
    const i = id.trim().toLowerCase();
    return this.listUsers().find(u => u.id.trim().toLowerCase() === i) || null;
  }

  listGamesByUser(userId: string): IGame[] {
    return this.listGames().filter(g => g.p1UserId === userId || g.p2UserId === userId);
  }


  upsertUser(user: IUser): IUser {
    const users = this.listUsers();
    const i = users.findIndex(u => u.id === user.id);
    if (i >= 0) users[i] = user; else users.push(user);
    this.save(this.USERS_KEY, users);
    return user;
  }

  addGame(g: IGame) {
    const games = this.listGames();
    games.push(g);
    this.save(this.GAMES_KEY, games);
  }
}
